export default __webpack_public_path__ + "static/media/LO10.e0768ba7.mp3";